import { CalendarDate, startOfMonth } from '@internationalized/date';

import { BenefitsWillExpireValueT } from '../types';
import { todayCentral } from '../utils/datetime';

export const MAX_BENEFITS_EXPIRATION_YEARS = 20;

export const benefitsExpirationValidationMessage = 'Select a valid benefits expiration date.';

export const benefitsWillExpireOptions = (['yes', 'no'] as BenefitsWillExpireValueT[]).map(
  (value) => ({
    label: value.charAt(0).toUpperCase() + value.slice(1),
    value,
  }),
);

export const validateBenefitsExpiration = (value: string | undefined): true | string => {
  if (!value || !/^\d{4}-\d{2}$/.test(value)) {
    return benefitsExpirationValidationMessage;
  }

  const [yearText, monthText] = value.split('-');
  const year = Number(yearText);
  const month = Number(monthText);

  if (month < 1 || month > 12) {
    return benefitsExpirationValidationMessage;
  }

  const minDate = startOfMonth(todayCentral());
  const maxDate = minDate.add({ years: MAX_BENEFITS_EXPIRATION_YEARS });
  const selectedDate = new CalendarDate(year, month, 1);

  if (selectedDate.compare(minDate) < 0 || selectedDate.compare(maxDate) > 0) {
    return benefitsExpirationValidationMessage;
  }

  return true;
};
